import { makeStyles } from '@material-ui/core';

export const useCasePlanCreateActionsStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '12px',
    width: '100%',
    height: '80px',
    padding: '0 24px',
    boxSizing: 'border-box',
    borderTop: `1px solid ${theme.palette.colors.grey60}`,
  },
  createDisabled: {
    minHeight: '40px',
    borderRadius: '100px',
    padding: '12px 20px',
    opacity: 0.8,
    backgroundColor: 'var(--greyscale---grey-30, #eff0f4) !important',
    color: `${theme.palette.colors.grey110} !important`,
    boxShadow: 'none !important',
    fontWeight: 700,
    fontSize: '16px',
    letterSpacing: '0.32px',
  },
  createEnabled: {
    minHeight: '40px',
    borderRadius: '100px',
    padding: '12px 20px',
    fontWeight: 700,
    fontSize: '16px',
    letterSpacing: '0.32px',
  },
  cancel: {
    minHeight: '40px',
    borderRadius: '100px',
    padding: '12px 20px',
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    backgroundColor: `${theme.textWhite.main} !important`,
    fontWeight: 700,
    fontSize: '16px',
    letterSpacing: '0.32px',
  },
}));
